import MediaGalleryAndListDisplay from './MediaGalleryAndListDisplay';

export default MediaGalleryAndListDisplay;
